// Actions
import { Dispatch, APIAction } from 'types'

// Schemas
import { pageSchema, pageSummaryListSchema } from 'modules/cms/models'

// Utils
import jsTracking from 'lib/jsTracking'

export const actions = {
  loadPage: (pageId: number): APIAction => {
    const endpoint = window.location && window.location.search === '?draft' ? 'drafts' : 'pages'
    return {
      CALL_API: {
        type: 'FETCH_STATIC_PAGE',
        method: 'GET',
        endpoint: `/api/static/${endpoint}/${pageId}/`,
        schema: pageSchema,
        requestKey: pageId,
        merge: true,
      },
    }
  },

  loadPageByPath: (path: string): APIAction => {
    const endpoint = window.location && window.location.search === '?draft' ? 'drafts' : 'pages'
    return {
      CALL_API: {
        type: 'FETCH_STATIC_PAGE',
        method: 'GET',
        endpoint: `/api/static/${endpoint}/find?html_path=${path}/`,
        schema: pageSchema,
        requestKey: path,
        merge: true,
      },
    }
  },

  loadDiscoverSubPages: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_DISCOVER_SUBPAGES',
      method: 'GET',
      endpoint: '/api/static/pages/?type=cms.discoversubpage&fields=id,title,summary&show_in_menus=true',
      schema: pageSummaryListSchema,
    },
  }),

  submit: (data: Record<string, unknown>, url: string) => (dispatch: Dispatch) =>
    dispatch(actions._submit(data, url)).then(resp => {
      jsTracking('Lead', 'Newsletter signup')
      return resp
    }),

  _submit: (data: Record<string, unknown>, url: string): APIAction => ({
    CALL_API: {
      type: 'CMS_FORM',
      method: 'POST',
      endpoint: url,
      data,
    },
  }),
}
